import { api } from "../../../services/api";

// POST (caso queira criar nova chave aleatória)
export async function fetchConfirmarSaques({ valorSaque, chaveSelecionada }) {
  const token = localStorage.getItem("@medusapayments:access_token");

  try {
    const response = await api.post(
      `/withdraw`,
      {
        amount: valorSaque,
        key_pix: chaveSelecionada
      }, // ou algum corpo, se necessário
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
}
